export default __webpack_public_path__ + "static/media/call-report.f860a983.svg";